import {State} from '../../types/state';
import {NameSpace} from '../root-reducer';
import { IPropsOrder } from './orders';

export const getAllOrders = (state: State): IPropsOrder[] | null | undefined => state[NameSpace.Orders].orders;
export const getOrdersCompanyName = (state: State): string => state[NameSpace.Orders].companyName;
export const getOrderNumberCar = (state: State): string => state[NameSpace.Orders].numberCar;
export const newRequestsCountOrders = (state: State): number[] => state[NameSpace.Orders].newRequestsCount;
